export default {
    text: {
        title: 'Texte',
        addText: 'Nouveau texte',
        fontFamily: 'Famille de polices de caractères',
        fontSize: 'Font size',
        textAlignment: 'Alignement du texte',
        fontColor: 'Couleur de police',
        lineSpacing: 'Interligne',
        arialSerif: 'Arial (sans empattement)',
        verdanaSansSerif: 'Verdana (sans-serif)',
        tahomaSansSerif: 'Tahoma (sans empattement)',
        trebuchetMSSansSerif: 'Trebuchet MS (sans-serif)',
        timesNewRomanSerif: 'Times New Roman (à empattements)',
        georgiaSerif: 'Géorgie (serif)',
        garamondSerif: 'Garamond (avec empattement)',
        courierNewMonospace: 'Courier New (mono-espace)',
        brushScriptMTCursive: 'Brosser le script MT (cursive)',
        backgroundColor: 'Couleur de fond',
    },
};
